import { createAction } from 'redux-actions';
import getGuid from 'ui-forms-editor-automation-lib/selectors/getGuid';
import createInfoAction from 'ui-forms-editor-automation-lib/utils/createInfoAction';
import createErrorAction from 'ui-forms-editor-automation-lib/utils/createErrorAction';
import postRemoveWebsiteFlows from 'ui-forms-editor-automation-lib/api/postRemoveWebsiteFlows';
export const REQUEST_REMOVE_WEBSITE_FLOWS = '@@lib/REQUEST_REMOVE_WEBSITE_FLOWS';
export const SUCCESS_REMOVING_WEBSITE_FLOWS = '@@lib/SUCCESS_REMOVING_WEBSITE_FLOWS';
export const SUCCESS_SCHEDULING_REMOVING_WEBSITE_FLOWS = '@@lib/SUCCESS_SCHEDULING_REMOVING_WEBSITE_FLOWS';
export const FAIL_REMOVING_WEBSITE_FLOWS = '@@lib/FAIL_REMOVING_WEBSITE_FLOWS';
const requestRemoveWebsiteFlows = createAction(REQUEST_REMOVE_WEBSITE_FLOWS);

/*const successRemovingWebsiteFlows = createInfoAction(
  SUCCESS_REMOVING_WEBSITE_FLOWS,
  'automationLib.infoMessages.emailRemovedSuccessTitle',
  'automationLib.infoMessages.emailRemovedSuccessBody'
);*/

const successSchedulingRemovingWebsiteFlows = createInfoAction(SUCCESS_SCHEDULING_REMOVING_WEBSITE_FLOWS, 'automationLib.infoMessages.emailIsBeingRemovedTitle', 'automationLib.infoMessages.emailIsBeingRemovedBody');
const failRemovingWebsiteFlows = createErrorAction(FAIL_REMOVING_WEBSITE_FLOWS, 'automationLib.errorMessages.failRemovingEmails', 'automationLib.errorMessages.failRemovingEmailsSteps');
const removeWebsiteFlows = providedGuid => (dispatch, getState) => {
  const state = getState();
  const guid = providedGuid || getGuid(state);
  dispatch(requestRemoveWebsiteFlows());
  return postRemoveWebsiteFlows(guid).then(flows => {
    dispatch(successSchedulingRemovingWebsiteFlows(flows));
  }).catch(error => {
    dispatch(failRemovingWebsiteFlows(error));
  });
};
export default removeWebsiteFlows;